import { INVITES_COLLECTION, USERS_COLLECTION } from '../../../constants'
import { FirestoreClient, UserInviteData } from '../../../types'
import { FirestoreAdmin } from '../../../types/FirestoreAdmin'
import firebase from 'firebase'

interface Props<T extends FirestoreClient | FirestoreAdmin> {
  firestore: T
  email: string
  userInviteId: string
}

export const getUserInviteRef = <T extends FirestoreClient | FirestoreAdmin>({
  firestore,
  email,
  userInviteId,
}: Props<T>): T extends FirestoreClient
  ? firebase.firestore.DocumentReference<UserInviteData>
  : FirebaseFirestore.DocumentReference => {
  return firestore
    .collection(USERS_COLLECTION)
    .doc(email)
    .collection(INVITES_COLLECTION)
    .doc(userInviteId) as any
}
